import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Menu, X, Shield, Bell } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a027839a-8849-4776-a8ba-c961dd10b69f/artifacts/co2pjy4b_IMG_20260323_062123.jpg";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const navLinks = [
    { label: 'HOME', path: '/' },
    { label: 'EPISODES', path: '/archive' },
    { label: 'ABOUT', path: '/about' },
    { label: 'MERCH', path: '/merch' },
    { label: 'SUBSCRIBE', path: '/subscribe', icon: <Bell size={14} /> },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header data-testid="main-header" className="fixed top-0 w-full z-50 bg-[#0A0A0A]/80 backdrop-blur-2xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL} alt="Let's Get In To It"
            className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover border-2 border-[#FF2A2A]/40 group-hover:border-[#FF2A2A] transition-colors"
          />
          <span className="font-heading text-lg md:text-xl uppercase tracking-tight hidden sm:block">
            LET'S GET IN TO IT
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <Link key={link.path} to={link.path} data-testid={`nav-${link.label.toLowerCase()}`}
              className={`flex items-center gap-1.5 font-body text-sm font-semibold tracking-wider transition-colors duration-200 ${
                isActive(link.path) ? 'text-[#FF2A2A]' : 'text-white/60 hover:text-white'
              }`}
            >
              {link.icon || null}
              {link.label}
            </Link>
          ))}
          {user && user.role === 'admin' && (
            <Link to="/admin" data-testid="nav-admin"
              className={`flex items-center gap-1.5 font-body text-sm font-semibold tracking-wider transition-colors duration-200 ${
                isActive('/admin') ? 'text-[#FF2A2A]' : 'text-white/60 hover:text-white'
              }`}>
              <Shield size={14} /> ADMIN
            </Link>
          )}
        </nav>

        <button data-testid="mobile-menu-toggle" onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-white p-2">
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <nav data-testid="mobile-nav" className="md:hidden bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/5 px-4 py-6 space-y-4">
          {navLinks.map((link) => (
            <Link key={link.path} to={link.path}
              data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              onClick={() => setMobileOpen(false)}
              className={`block font-heading text-2xl uppercase ${isActive(link.path) ? 'text-[#FF2A2A]' : 'text-white/60'}`}>
              {link.label}
            </Link>
          ))}
          {user && user.role === 'admin' && (
            <Link to="/admin" onClick={() => setMobileOpen(false)} data-testid="mobile-nav-admin"
              className="block font-heading text-2xl uppercase text-white/60">ADMIN</Link>
          )}
        </nav>
      )}
    </header>
  );
}
